import React from 'react';
import {useAtom} from "jotai";
import {modalState} from "../../../states/action";


/**
 새로 고침

 * @param data1 설명
 * @return {data1} 반환
 * @throws ValidException 예외 발생
 * @author plaq99@rumpus.co.kr
 * @date 03-20-2023
 */

export default function HeaderInformation() {

  const [{modalOn}, setModalOn] = useAtom(modalState);

  return (
    <>
      <button type="button" className="btn_information">
        <i
          className="bi bi-info-circle"
          onClick={() => {
            setModalOn({
              modalOn:modalOn ? modalOn : !modalOn,
              modalTitle: '도움말',
              modalContentName:'ModalInformation'
            })
          }}
        ></i>
      </button>
    </>
  );
}
